export default __webpack_public_path__ + "static/media/speech_mechanism.f4351014.jpg";